import React from 'react'
import styled from 'styled-components'
import { LoadingIndicator } from '~common/components/loading'
import type { Theme } from '~common/theme/types'

export interface LoadingScreenProps {
    message?: string
    error?: string | null
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
    message = 'Loading application...',
    error,
}) => {
    return (
        <Container>
            <Content>
                <LoadingIndicator size="large" />
                {error ? (
                    <ErrorMessage>{error}</ErrorMessage>
                ) : (
                    <Message>{message}</Message>
                )}
            </Content>
        </Container>
    )
}

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) =>
        (theme as Theme).colors?.background?.bg1 || '#ffffff'};
    z-index: 9999;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => (theme as Theme).spacing?.[6] || '24px'};
    text-align: center;
`

const Message = styled.p`
    color: ${({ theme }) => (theme as Theme).colors?.text?.secondary || '#666'};
    font-size: ${({ theme }) =>
        (theme as Theme).typography?.fontSize?.lg || '18px'};
    margin: 0;
    font-weight: ${({ theme }) =>
        (theme as Theme).typography?.fontWeight?.medium || 500};
`

const ErrorMessage = styled.p`
    color: ${({ theme }) => (theme as Theme).colors?.error || '#ff4747'};
    font-size: ${({ theme }) =>
        (theme as Theme).typography?.fontSize?.lg || '18px'};
    margin: 0;
    font-weight: ${({ theme }) =>
        (theme as Theme).typography?.fontWeight?.medium || 500};
`
